import { Component, Vue } from 'vue-property-decorator'
import DefaultLayout from '@/components/Layouts/Default'
import GameFooter from '@/components/Game/Footer'
import { EventBus } from '@/utils/eventbus'
import Axios from 'axios'
import { config } from '@/../app.config'
import _ from 'lodash'
import { GetGeoData, FormatCurrency } from '@/utils/GameUtils'
import { IPaymentSession } from './Account'
import { ErrorMessageLookup } from '@/utils/GameUtils'

@Component
export default class AddFunds extends Vue {

  private async deposit() {
    const geoBundle = await GetGeoData()

    //@ts-ignore
    heap.track('account:deposit:init')

    Axios.post(`${config.apiEndpoint}/auth/paymentgatewaysession`, {
      geo: geoBundle
    })
    .then( (res) => {
      const payload = res.data as IPaymentSession
      this.gatewayPayload = payload
      this.buildPaymentGatewayScriptTag(payload.sessionurl)
      //@ts-ignore
      heap.track('account:deposit:deposit')
    })
    .catch( (err) => {
      if (err.response.data && err.response.data.code) {
        //@ts-ignore
        heap.track('account:withdrawal:failure', {'code': err.response.data.code})
        const error = ErrorMessageLookup()[err.response.data.code] || ErrorMessageLookup()[0]
        //@ts-ignore
        //this.$awn.alert(error)
        this.genErrorDialog(error)
        return;
      }
      console.log('session error ->', err, err.response, err.response.data)
      // @ts-ignore
      if (err.response.data === 'You cannot make a payment from this location') {
        this.genErrorDialog(`We're unable to accept deposits from your current location`)
        return 
      }
      this.genErrorDialog('Could not connect to the payment gateway. Please try again later')
    })
  }

  private genErrorDialog(msg: string) {
    this.$modal.show('dialog', {
      text: msg,
      buttons: [
        {
          title: 'Close'
        }
     ],
    })
  }

  private created() {
    this.deposit()

    EventBus.$on('paymentSessionStarted', () => {
      this.toggleLoader(true)
    })

    EventBus.$on('paymentSessionComplete', () => {
      // @ts-ignore
      heap.track('account:deposit:complete')
      this.$router.push('wallet')
    })

    EventBus.$on('paymentSessionError', () => {
      
    })
  }

  private toggleLoader(show: boolean) {
    const scr = document.querySelector('.lds-grid')
    if (scr) {
      if (show) { 
        scr.classList.add('hidden')
        return
      }
      scr.classList.remove('hidden')
    }
  }

  private buildPaymentGatewayScriptTag(sessionURL: string) {
    const node = decodeURIComponent(sessionURL.replace(/\+/g,  ' '))
    const range = document.createRange()
    const documentFragment = range.createContextualFragment(node)
    document.body.appendChild(documentFragment)
    document.body.classList.add('payment-active')
  }

  gatewayPayload: IPaymentSession | null

  private clearNodes() {
    const scr = document.querySelector('script[data-tsevo-script-tag]')
    if (scr && scr.parentNode) {
      scr.parentNode.removeChild(scr)
      document.body.classList.remove('payment-active')
    }

    const gdx = document.querySelector('#GIDX_ServiceContainer')
    if (gdx) {
      Array.from(gdx.children).forEach( (child) => {
        if (!child.classList.contains('lds-grid')) {
          child.remove()
        }
      })
    }
  }

  private beforeDestroy() {
    this.clearNodes()
    this.toggleLoader(false)
    this.gatewayPayload = null
  }

  private render(h: any) {
    return (
        <DefaultLayout>
          <div id='GIDX_ServiceContainer'>
            <div class='lds-grid dark'><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
          </div>

          <div slot='navigation'>
            <h1 class='navigation-title'>{this.$route.meta.title}</h1>
            <router-link class='navigation-link home' to='/account'>Account</router-link>
            <p class='navigation-user'>{this.$store.getters.USERNAME}</p>
            <router-link class='navigation-balance' to='/account'>{`${FormatCurrency(this.$store.getters.BALANCE)}`}</router-link>
          </div>

          <GameFooter></GameFooter>
        </DefaultLayout>
    );
  }
}
